import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { BulkActionType } from './bulkActions.types';

const ENDPOINT = `${APIConfiguration.search}bulkActions/byIds`;

export interface CreateBulkActionJobByIdsArgs {
  itemIds: string[];
  actionType: BulkActionType;
  actionParameters?: unknown;
  tenantId?: string;
  sellerId?: string;
}

async function createBulkActionJobByIdsCommand({
  itemIds,
  actionType,
  actionParameters,
  tenantId,
  sellerId,
}: CreateBulkActionJobByIdsArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<string>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        itemIds,
        actionType,
        actionParameters,
        tenantId,
        sellerId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default createBulkActionJobByIdsCommand;
